<template>
  <div class="main-wrapper">
    <div class="wrap-label-head">
      <label class="lbl">Dropshadow</label>
      <div class="wap-toggle">
        <GfToggle :checked="false" @onChange="toggleSetting" />
      </div>
    </div>
    <div class="wrap-color-setting" :data-expanded="isOpen">
      <div class="wrap-row">
        <div class="left-col">
          <div class="wrap-form-row">
            <div class="wap-form-left left-fix-size">
              <label class="lbl">Color</label>
            </div>
            <div class="wap-form-right">Color input</div>
          </div>
        </div>
        <div class="right-col">
          <div class="wrap-form-row">
            <div class="wap-form-left"></div>
            <div class="wap-form-right"></div>
          </div>
        </div>
      </div>
      <div class="wrap-row">
        <div class="left-col">
          <div class="wrap-form-row">
            <div class="wap-form-left left-fix-size">
              <label class="lbl">Distance</label>
            </div>
            <div class="wap-form-right">
              <GfInputUnit :units="inputUnit" />
            </div>
          </div>
        </div>
        <div class="right-col">
          <div class="wrap-form-row">
            <div class="wap-form-left">
              <label class="lbl">Blur</label>
            </div>
            <div class="wap-form-right">
              <GfInputUnit :units="inputUnit" />
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-row">
        <div class="left-col">
          <div class="wrap-form-row">
            <div class="wap-form-left left-fix-size">
              <label class="lbl">Angle</label>
            </div>
            <div class="wap-form-right">
              <GfInputUnit :units="inputUnit" />
            </div>
          </div>
        </div>
        <div class="right-col">
          <div class="wrap-form-row">
            <div class="wap-form-left">
              <label class="lbl">Size</label>
            </div>
            <div class="wap-form-right">
              <GfInputUnit :units="inputUnit" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GfToggle from '@/core/components/base/GfToggle';
import GfInputUnit from '@/core/components/base/GfInputUnit';

export default {
  name: 'DropShadow',
  components: {
    GfToggle,
    GfInputUnit,
  },
  data: () => ({
    isOpen: false,
    inputUnit: [
      {
        name: 'px',
        value: 'px',
      },
    ],
  }),
  methods: {
    toggleSetting(value) {
      this.isOpen = value;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.main-wrapper {
  color: $highlight15;
  font-size: 11px;
  line-height: 14px;

  .wrap-label-head {
    display: flex;

    .lbl {
      flex: 0 0 50%;
      display: flex;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      justify-content: flex-start;
      color: $highlight15;
      align-items: center;
    }

    .wap-toggle {
      flex: 0 0 50%;
      display: flex;
      justify-content: flex-end;
    }
  }

  .wrap-color-setting {
    background: $black2;
    border-radius: $radius;
    -moz-border-radius: $radius;
    -webkit-border-radius: $radius;
    margin-top: 10px;
    padding: 10px 20px 0 20px;
    flex-direction: column;
    display: none;

    &[data-expanded='true'] {
      display: flex;
    }

    .wrap-form-row {
      display: flex;
      justify-content: flex-end;

      .wap-form-left {
        flex: 0 0 22%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-right: 5px;

        .lbl {
          padding-bottom: 0;
        }
      }

      .left-fix-size {
        flex-basis: 42%;
      }

      .wap-form-right {
        flex: 0 0 50%;
      }
    }

    .wrap-row {
      display: flex;
      margin-bottom: 12px;

      .left-col {
        flex: 0 0 50%;
      }

      .right-col {
        flex: 0 0 50%;
      }
    }
  }
}
</style>
